import * as React from 'react';
import {
  Card, CardContent, Typography, useTheme, styled,
} from '@mui/material';

const CardContainer = styled(Card)(({ theme }) => ({
  boxShadow: '0 1px 6px 0 rgba(32, 33, 36, .28)',
}));

const CardSubContent = styled(CardContent)(({ theme }) => ({
  padding: 25,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

function ErrorCard(props: ErrorCardProps) {
  const { children, errorImage } = props;

  const theme = useTheme();

  return (
    <CardContainer sx={{ maxWidth: 250 }}>
      <CardSubContent theme={theme}>
        {errorImage}
        <Typography variant="body1" mt={2}>
          { children }
        </Typography>
      </CardSubContent>
    </CardContainer>
  );
}

export interface ErrorCardProps {
  children: React.ReactNode;
  errorImage: JSX.Element;
}

export { ErrorCard };
